import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
    setIsDropdownOpen(false);
  };

  const toggleDropdown = (e) => {
    e.preventDefault();
    setIsDropdownOpen(!isDropdownOpen);
  };

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  return (
    <div className="main-menuwrap">
      <div className="topbar">
        <div className="container">
          <div className="row">
            <div className="col-md-8">
              <ul className="list-inline">
                <li><i className="fa fa-clock-o"></i> MON - FRI - IST - 09.00AM - 07.00PM</li>
                <li><i className="fa fa-phone"></i> CALL US: <a href="tel:+919448165266">+91 944 816 5266</a></li>
                <li><i className="fa fa-envelope"></i> <a href="mailto:svgadag_12@yahoo.com">svgadag_12@yahoo.com</a></li>
              </ul>
            </div>
            <div className="col-md-4 text-right hidden">
              <ul className="list-inline contacto-topbar">
                <li><Link to="/about/careers">Careers</Link></li>
                <li><Link to="/contact-us">Contact Us</Link></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      
      <nav className="navbar navbar-default yamm" role="navigation">
        <div className="container">
          <div className="navbar-header">
            <Link className="navbar-brand" to="/">
              <img src="/assets/logo.svg" alt="S. V. Gadag logo" />
              <span>S. V. Gadag Ginning Factory</span>
            </Link>
            <button 
              type="button" 
              className="navbar-toggle" 
              onClick={toggleMenu}
            >
              <span className="sr-only">Toggle navigation</span>
              <span className="icon-bar"></span>
              <span className="icon-bar"></span>
              <span className="icon-bar"></span>
            </button>
          </div>
          
          <div className={`collapse navbar-collapse ${isMenuOpen ? 'show' : ''}`}>
            <ul className="nav navbar-nav navbar-right">
              <li className={isActive('/')}>
                <Link to="/" onClick={closeMenu}>Home</Link>
              </li>
              <li className={`dropdown ${location.pathname.startsWith('/about') || location.pathname.startsWith('/about/infrastructure') || location.pathname.startsWith('/about/careers') ? 'active' : ''} ${isDropdownOpen ? 'active' : ''}`}>
                <Link to="/about/about-us" className="dropdown-toggle" onClick={toggleDropdown}>
                  About <span className="caret"></span>
                </Link>
                <ul className="dropdown-menu">
                  <li className={isActive('/about-us')}>
                    <Link to="/about/about-us" onClick={closeMenu}>About Us</Link>
                  </li>
                  <li className={isActive('/about/infrastructure')}>
                    <Link to="/about/infrastructure" onClick={closeMenu}>Infrastructure</Link>
                  </li>
                  <li className={isActive('/about/careers')}>
                    <Link to="/about/careers" onClick={closeMenu}>Careers</Link>
                  </li>
                </ul>
              </li>
              <li className={isActive('/products')}>
                <Link to="/products" onClick={closeMenu}>Products</Link>
              </li>
              <li className={isActive('/quality')}>
                <Link to="/quality" onClick={closeMenu}>Quality</Link>
              </li>
              <li className={isActive('/contact-us')}>
                <Link to="/contact-us" onClick={closeMenu}>Contact Us</Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Header;
